var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('mobile-header',{staticClass:"is-hidden-desktop",attrs:{"home-url":_vm.homeUrl}}),_c('desktop-header',{staticClass:"is-hidden-mobile is-hidden-tablet-only",attrs:{"home-url":_vm.homeUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }